<template>
<div>
  <div class="card card-form">
    <div class="card-header" >
      <div class="row" >
        <div class="col-12">
          <div class="pull-left">
            <h4 class="card-title float-left" >
              <span><i class="fa fa-role"></i>
                <label class="label">{{title}} <code>*</code></label>
              </span>
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" >
      <div v-for="option in options" :key="option.code">
        <input
            @input="(event) => check(option, event.target.checked)"
            type="checkbox"
            :checked="action!=='ADD' && value.some(e => e.trim() === option.code.trim())"
            :id="option.id"
            :disabled="option.disabled"
            class="mr-2 hidden"
            @click="onClick(option, $event)"
        />
        <label :for="option.id" class="flex flex-row items-center font-bold text-gray-800 cursor-pointer select-none">
          {{ option.name }}
        </label>
      </div>

    </div>
    <div class="card-footer">

    </div>

  </div>
</div>
</template>

<script>

export default {
  emits: ["update:value"],
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
      required: true,
      // validator: (value) => {
      //   const hasNameKey = value.every((option) =>
      //       Object.keys(option).includes("name")
      //   );
      //   const hasIdKey = value.every((option) =>
      //       Object.keys(option).includes("id")
      //   );
      //   return hasNameKey && hasIdKey;
      // },
    },
    action: {
      type: String,
      default: "EDIT",
    }
  },
  data() {
    return {
      ids: []
    }
  },
  // setup(props, context) {
  //   const check = (optionId, checked) => {
  //     let updatedValue = [...props.value];
  //     if (checked) {
  //       updatedValue.push(optionId);
  //     } else {
  //       updatedValue.splice(updatedValue.indexOf(optionId), 1);
  //     }
  //     context.emit("update:value", updatedValue);
  //   };
  //
  //   return {
  //     check,
  //   };
  // },
  methods: {
    check(option, event) {
      console.log(option);
      console.log(event);

      // if (this.value.some(e => e === 'ROLE_FINANCIER')) {
      //   this.$swal({
      //     title: this.$t('messages.common.warning'),
      //     text: this.$t('messages.common.errorOccurred'),
      //     type: 'warning',
      //     html: "Оддий фойдаланувчи>>бошка рол бўлиши мумкин эмас!."
      //   });
      //   return;
      // }

      // console.log(this.value, option, event);
      // let updatedValue = [this.props.value];
      // if (event) {
      //   this.value.push(option.code.trim());
      //   this.ids.push(option.id.trim());
      // } else {
      //   this.value.splice(this.value.indexOf(option.code.trim()), 1);
      //   this.ids.splice(this.ids.indexOf(option.id.trim()), 1);
      // }
      // console.log(this.value);

      // this.$emit('change-multi-checkbox', this.value);
      this.$emit('change', this.value, option, event);

    },
    onMessage(message) {
      this.$swal({
        title: this.$t('messages.common.warning'),
        text: this.$t('messages.common.errorOccurred'),
        type: 'warning',
        html: message
      });
    },
    onClick(option, $event) {
      // let checked = $event.target.checked;
      var checked = $event.srcElement.checked;

      let id = option.id;

      if (checked) {
        this.value.push(option.code.trim());
        this.ids.push(option.id);
      } else {
        this.value.splice(this.value.indexOf(option.code.trim()), 1);
        this.ids.splice(this.ids.indexOf(option.id), 1);
      }

      var error = false;
      var employeeRoleCodes = [];
      var employeeData = {
        roleIds: this.ids
      };

      for (let i = 0; i < employeeData.roleIds.length; i++) {
        employeeRoleCodes.push(employeeData.roleIds[i].toString());
      }

      var isId5 = false;
      var isId8 = false;
      var count = 0;
      for (var i = 0; i < employeeRoleCodes.length; i++) {
        if (employeeRoleCodes[i] === "5"){
          isId5 = true;
        }
        if (employeeRoleCodes[i] === "8"){
          isId8 = true;
        }
        count++;
      }

      var roleText = "";
      if ((isId5 === true && isId8 === true) && count > 2) {
        roleText = "<<Худудий рахбар>> ва <<Баҳоловчи ёрдамчиси>> бошка роллар билан танланиши мумкин эмас!.";

        this.onMessage(roleText)
        error = true;
        //$event.preventDefault()
      }

      if ((isId5 === true && isId8 === false) && count > 1) {
        roleText = "<<Баҳоловчи ёрдамчиси>> (<<Худудий рахбар>> билан мумкин) бошкаси билан танланиши мумкин эмас!.";

        this.onMessage(roleText)
        error = true;
        //$event.preventDefault()
      }

      if ((isId5 === false && isId8 === true) && count > 1) {
        roleText = "<<Худудий рахбар>> (<<Баҳоловчи ёрдамчиси>> билан мумкин) бошкаси билан танланиши мумкин эмас!.";

        this.onMessage(roleText)
        error = true;
        //$event.preventDefault()
      }

      var roleLength = employeeData.roleIds.length;
      if (roleLength > 1 && (id === "6" || id === "7")) {
        roleText = (id === "6" ? "<<Оддий фойдаланувчи>>" : "<<Молиячи>>") + "бошка рол бўлиши мумкин эмас!.";
        this.onMessage(roleText)
        error = true;
        //$event.preventDefault()
      }

      var firstRole = employeeData.roleIds[0];
      // var lastRole = employeeData.roleIds[roleLength - 1];
      if (roleLength > 1 && (firstRole == 6 || firstRole == 7)) {
        roleText = (firstRole == 6 ? "<<Оддий фойдаланувчи>>" : "<<Молиячи>>") + "бошка рол бўлиши мумкин эмас!.";

        this.onMessage(roleText)
        error = true;
        //employeeData.roleIds.splice(employeeData.roleIds.indexOf(lastRole), 1);
      }

      if (error) {
        $event.preventDefault()
        console.log(this.value)
        this.value.splice(this.value.indexOf(option.code.trim()), 1);
        this.ids.splice(this.ids.indexOf(option.id), 1);
      }
    }
  },
  mounted() {
    setTimeout(() => {
      for (let i = 0; i < this.options.length; i++) {
        const roleCode = this.options[i];
        if (this.value.some(e => e.trim() === roleCode.code.trim())) {
          this.ids.push(roleCode.id);
        }
      }
    }, 1000);
  },
};
</script>
